import { Component, ChangeDetectionStrategy, OnInit, AfterViewInit, OnDestroy, ViewEncapsulation, Input, Inject, ChangeDetectorRef, ViewChild, ViewContainerRef, TemplateRef } from '@angular/core';
import { ChannelService, DetectChanges, DmDataModelManagerService, DmWidgetManagerService, HooksInterceptor, Message } from '@nexxe/core';
import { IWidget, IChangeDetector, ChangeDetectorMode, IStoreChange } from '@nexxe/core-types';
import { CustomerInfoEntryService } from './services/bn-customer-info-v2.service';
import { InjectionContext } from '@nexxe/plugin-injector';
import { Sections } from '@nexxe/bn-registration-core-services'
import { of, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as _ from 'lodash';
declare var userInfo: any;
@Component({
  selector: 'bn-customer-info-v2-component',
  templateUrl: './bn-customer-info-v2.component.html',
  styleUrls: ['./bn-customer-info-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
 })
export class BnCustomerInfoV2Component implements OnInit, AfterViewInit, OnDestroy {
  @Input('config') config: IWidget;

  currentProject: any;
  currentProjectMetaData: any;
  widgetManifestPath: string;
  widgetConfig: any;
  widgetChildContext: InjectionContext;

  widgetManagerId;
  widgetId;
  dataModelId;
  streamSubscription;
  constructor(
    private cdRef: ChangeDetectorRef,
    private customerInfoEntryService: CustomerInfoEntryService,
    private dmDataModelManagerService: DmDataModelManagerService,
    private dmWidgetManagerService: DmWidgetManagerService,
    public channelService: ChannelService,) { }
  ngOnInit(): void {
    if (!this.config) return;
    this.widgetManagerId = this.config.managerId;
    this.widgetId = this.config.widgetId;
    this.dataModelId = this.config.children[0].dataModelId;
    let itemDetails = this.dmDataModelManagerService.getById(this.dataModelId);
    if (!itemDetails) return;

    this.streamSubscription = new Subscription();

    this.currentProject = this.dmDataModelManagerService.getById('currentProject');
    this.currentProjectMetaData = this.dmDataModelManagerService.getById(this.currentProject);
    this.widgetConfig = { config: this.config, scope: this.customerInfoEntryService };
    this.widgetManifestPath = `${this.currentProjectMetaData.connectors['nexxe.widget'].name}@${this.currentProjectMetaData.connectors['nexxe.widget'].version}`
    this.bindSubscriptions();
    this.bindBnEntrySubscription();
    // if(userInfo.EnableUserNameAsEmailFeatureSetting && userInfo.BuyerInvitationDetails.SingleUserNameExists==true){
    //   this.customerInfoEntryService.callNotification("UseSingleUserName");
    // }
    if(userInfo.EnableUserNameAsEmailFeatureSetting && userInfo.BuyerInvitationDetails.MultiUserNameExists==true){
      this.customerInfoEntryService.callNotification("MultiUserNameLinked");
    }
    if(userInfo.EnableUserNameAsEmailFeatureSetting && userInfo.BuyerInvitationDetails.MultiUserNameExists==false && userInfo.BuyerInvitationDetails.SingleUserNameExists==false && (userInfo.BuyerInvitationDetails.UserName == ""
      || _.isEmpty(userInfo.BuyerInvitationDetails.UserName)
      || _.isUndefined(userInfo.BuyerInvitationDetails.UserName)
      || _.isNull(userInfo.BuyerInvitationDetails.UserName))){
      this.customerInfoEntryService.callNotification("BuyerUserNameLinked");
    }
  }

  bindSubscriptions() {
    this.streamSubscription.add(this.dmWidgetManagerService.configStream$
      .pipe(filter(_ => _.patch.storeId === this.widgetManagerId))
      .subscribe((change: IStoreChange) => {
        if (this.dmWidgetManagerService.has(this.widgetManagerId)) {
          if (this.widgetChildContext) {
            this.widgetChildContext.resolved.refrences.component.instance.config = this.dmWidgetManagerService.getWidgetById(this.widgetManagerId, this.widgetId);
          }
          this.config = this.dmWidgetManagerService.getWidgetById(this.widgetManagerId, this.widgetId);
          this.widgetConfig.config = this.dmWidgetManagerService.getWidgetById(this.widgetManagerId, this.widgetId);
          if (!this.cdRef['destroyed']) {
            this.cdRef.detectChanges();
          }
        }
      }));
  }
  bindBnEntrySubscription() {
    this.streamSubscription.add(this.channelService.subscribe(this.processMessage.bind(this), 'entry-component', this.bindBnEntry.bind(this)));
  }
  processMessage() {
    return of(true);
  }
  bindBnEntry(message: Message) {
    if (message.from == 'resetcustomerwidget') {
      let supplierUserData = this.customerInfoEntryService.getSectionDefaultData(Sections.UserInfoRegistration);
      _.forIn(supplierUserData.userInfo, (value, prop) => {
        this.dmDataModelManagerService.setIn(Sections.UserInfoRegistration, ["userInfo", prop], value);

      });
      this.widgetConfig.config.children.forEach((element: any) => {
        this.dmWidgetManagerService.setInField(this.widgetManagerId, this.widgetId,
          element.fieldId, ['validation', 'message'], '');
      });
    }
    this.cdRef.detectChanges();
  }
  onWidgetActivate(event) {
    this.widgetChildContext = event;
  }

  ngAfterViewInit(): void { }
  ngOnDestroy(): void { }
  onDeinitialize(event) { }
  onInitialize(event) { }
}
